import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ReplaySubject } from 'rxjs';

type HttpErrorStatusBarEvent = {
  message: string;
  route: string;
};

@Injectable({ providedIn: 'root' })
export class HttpErrorStatusBarService {
  private readonly translateService = inject(TranslateService);
  private readonly router = inject(Router);
  private readonly errorSubject = new ReplaySubject<HttpErrorStatusBarEvent>(1);

  public readonly error$ = this.errorSubject.asObservable();

  public reportGenericError(): void {
    const translationKey = 'COMMON.ERRORS.API.GENERIC_ERROR';
    const translated = this.translateService.instant(translationKey);
    const message = translated && translated !== translationKey ? translated : this.translateService.instant('COMMON.ERRORS.API.GENERIC_ERROR');

    this.errorSubject.next({
      message,
      route: this.router.url,
    });
  }

  public clear(): void {
    this.errorSubject.next({ message: '', route: '' });
  }
}
